import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import type { FulfillmentProvider } from '@/types/integration';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'query' | 'limit'>;

export const getFulfillmentProviders = async (
  scope: RequestScope,
  params: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<FulfillmentProvider[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<FulfillmentProvider[]>>('/fulfillment_provider', { ...options, params });
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
